import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

// material ui components
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import CircularProgress from "@material-ui/core/CircularProgress";

//icons
import ChevronRight from "@material-ui/icons/ChevronRight";
import SaveIcon from "@material-ui/icons/Save";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";

//styles
import useStyles from "./styles/wilayah";

// //hooks
import { usePouchDB } from "../../../components/PouchDB/PouchDBProvider";
import { useSnackbar } from "notistack";

//app components
import { ScrollToTopWithoutRouter } from "../../../components/ScrollToTop";

import { Swipeable } from "react-swipeable";
// import Swal from 'sweetalert2';

import isInt from "validator/lib/isInt";

// redux implementation
import { withRouter } from "react-router-dom";
// import { connect } from "react-redux";
// import { setKeluarga } from "../../../actions/keluarga";
import { compose } from "redux";
import { useDataSync } from "../../../components/PouchDB/DataSyncProvider";
import { validatePerKepala } from "./validatePerKepala";

function Wilayah({
  wilayah,
  setWilayah,
  handleNext,
  mode,
  keluarga,
  kb,
  setKeluarga,
  docKK,
  history,
  handleSegmen,
  handleAnomali,
  setForms,
}) {
  const classes = useStyles();
  const nextRef = useRef(null);
  // const { user: { metadata, dataBkkbn } } = usePouchDB();
  const {
    user: { metadata },
    dataKK,
    dataKB,
    dataPK,
    dataBkkbn,
    dataRekap,
  } = usePouchDB();
  //
  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState({});
  const [backup, setBackup] = useState([]);
  const { isSyncing, isManualSyncing } = useDataSync();
  const [isSomethingChange, setSomethingChange] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);

  const [isSaved, setSaved] = useState({
    local: false,
    remote: false,
  });

  const [stopSegment, setStopSegment] = useState(true);
  const [jmlKeluarga, setJmlKeluarga] = useState(wilayah.jumlah_keluarga || "");
  const [stsKeluarga, setStsKeluarga] = useState(wilayah.sts_keluarga || "");
  const [lock, setLock] = useState(false);
  const [lockOver, setLockOver] = useState(false);
  const [lockKeluarga, setLockKeluarga] = useState(false);
  const [disabledSk, setDisabledSk] = useState(false);
  const [skipSk6, setSkipSk6] = useState(false);
  const [blocking, setBlocking] = React.useState(false);

  const [persentase, setPersentase] = useState(0);
  const [persentaseOpsi, setPersentaseOpsi] = useState(0);
  const [totalDataKKAll, setTotalDataKKAll] = useState(0);
  const [wilayahkerja, setWilayahKerja] = useState("");
  const [targetkk, setTragetKK] = useState(0);
  const [opr, setOpr] = useState(localStorage.getItem("opr"));
  const [localRw, setLocalRw] = useState(localStorage.getItem("rw"));
  // const [lock, setLock] = useState(localStorage.getItem("lock"))
  const [lockWilayah, setLockWilayah] = useState(
    localStorage.getItem("lockWilayah")
  );

  //----- Check Network Online state -----//
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    // Update network status
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);
    };

    // Listen to the online status
    window.addEventListener("online", handleStatusChange);

    // Listen to the offline status
    window.addEventListener("offline", handleStatusChange);

    // Specify how to clean up after this effect for performance improvment
    return () => {
      window.removeEventListener("online", handleStatusChange);
      window.removeEventListener("offline", handleStatusChange);
    };
  }, []);
  //----- End Check Network Online state -----//

  //cek GPS on
  const [locationUser, setLocationUser] = useState([]);

  const getLocationUser = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        setLocationUser([
          {
            latitude: position.coords.latitude,
          },
          {
            longitude: position.coords.longitude,
          },
        ]);
      });
    } else {
    }
  };

  useEffect(() => {
    getLocationUser();
    // console.log("wilayah: ", wilayah);
  }, []);

  // PERUBAHAN AMBIL YANG RT RW BKKBN
  useEffect(() => {
    if (!wilayah.hasOwnProperty("no_kk_verval")) {
      setWilayah({
        ...wilayah,
        no_kk_verval: "",
      });
    }

    // Inisialisasi field no_kk_lama jika belum ada
    if (!wilayah.hasOwnProperty("no_kk_lama")) {
      setWilayah({
        ...wilayah,
        no_kk_lama: "",
      });
    }
    if (!wilayah.hasOwnProperty("no_kk")) {
      setWilayah({
        ...wilayah,
        // ['no_kk'] : Date.now().toString()
        // ['no_kk'] : `${metadata.wil_provinsi.id_provinsi}${metadata.wil_kabupaten.id_kabupaten}${metadata.wil_kecamatan.id_kecamatan}${metadata.wil_kelurahan.id_kelurahan}`
      });
    }

    if (mode !== "edit") {
      setDisabledSk(true);
      setSkipSk6(false);
      setWilayah({
        ...wilayah,
        sts_keluarga: "5",
        year_doc: "2025",
      });
      setStsKeluarga("5");
    } else {
      if (wilayah.year_doc && wilayah.year_doc === "2025") {
        setDisabledSk(true);
        setSkipSk6(false);
        setWilayah({
          ...wilayah,
          sts_keluarga: "5",
        });
        setStsKeluarga("5");
      } else {
        setDisabledSk(false);
        setSkipSk6(true);
      }
    }
  }, []);

  useEffect(() => {
    const getAllDataKK = async () => {
      let total = 0;
      let target_kk = 0;
      let selector = {
        user_name: { $eq: metadata.nameProses },
      };

      if (opr === "true" && localRw !== "false") {
        selector = {
          user_name: { $eq: metadata.nameProses },
          id_rw: { $eq: localRw },
        };
      }

      try {
        const query = await dataBkkbn.local.find({
          selector,
        });

        let all = [];

        query.docs.forEach((item) => {
          if (item.status_sensus !== "Delete") {
            if (
              item.status_sensus === "Received" ||
              item.status_sensus === "Valid" ||
              item.status_sensus === "Anomali" ||
              item.status_sensus === "Anomali Terkonfirmasi" ||
              item.status_sensus === "NotValid" ||
              (item.status_draft === "2" &&
                (item.status_sensus === "" ||
                  item.status_sensus === "Tersimpan"))
            ) {
              if (item.sts_keluarga === "1" || item.sts_keluarga === "5") {
                all.push(item);
              }
            }
          }
        });
        total = all.length;
      } catch (error) {}

      if (metadata.wil_rw.length > 0) {
        let rwName = [];
        let rtName = [];
        if (opr === "true" && localRw !== "false") {
          metadata.wil_rw.forEach((rw) => {
            rwName.push(rw.nama_rw);
            if (rw.wil_rt.length > 0) {
              if (parseInt(rw.id_rw) === parseInt(localRw)) {
                rw.wil_rt.forEach((rt) => {
                  rtName.push(rt.nama_rt);
                  //)
                  let targetRT = rt.targetkk;
                  if (String(rt.targetkk) === "null") {
                    //
                    targetRT = 0;
                  }

                  target_kk = target_kk + parseInt(targetRT);
                });
              }
            }
          });
        } else {
          metadata.wil_rw.forEach((rw) => {
            rwName.push(rw.nama_rw);
            if (rw.wil_rt.length > 0) {
              rw.wil_rt.forEach((rt) => {
                rtName.push(rt.nama_rt);
                //)
                let targetRT = rt.targetkk;
                if (String(rt.targetkk) === "null") {
                  //
                  targetRT = 0;
                }

                target_kk = target_kk + parseInt(targetRT);
              });
            }
          });
        }
      }

      // if (total < target_kk && (wilayah.sts_keluarga === '1' || wilayah.sts_keluarga === '6')) {
      //     // if (target_kk < total) {
      //     setLockOver(false)
      // } else {

      //     setLockOver(true)
      //     enqueueSnackbar("Jumlah yang didata telah tercapai", { variant: 'error' })
      // }
    };
    getAllDataKK();
  }, []);

  useEffect(() => {
    const getSelectedDataRekap = async () => {
      try {
        const query = await dataBkkbn.local.find({
          selector: {
            user_name: { $eq: metadata.nameProses },
          },
        });

        let newDocs = [];
        let targetkk = metadata.wil_rw
          .find((rw) => parseInt(rw.id_rw) === parseInt(wilayah.id_rw))
          .wil_rt.find(
            (rt) => parseInt(rt.id_rt) === parseInt(wilayah.id_rt)
          ).targetkk;

        query.docs.forEach((item) => {
          if (item.status_sensus !== "Delete") {
            // if (item.status_draft === '2' && (item.sts_keluarga === '1' || item.sts_keluarga === '6') && (item.status_sensus === 'Valid' || item.status_sensus === 'Anomali' || item.status.sensus === 'Anomali Terkonfirmasi')) {
            if (
              item.status_draft === "2" &&
              (item.sts_keluarga === "1" || item.sts_keluarga === "5")
            ) {
              if (parseInt(item.id_rt) === parseInt(wilayah.id_rt)) {
                newDocs.push(item);
              }
            }
          }
        });

        const getDataRekap = await dataBkkbn.local.find({
          selector: {
            user_name: { $eq: metadata.nameProses },
            periode_sensus: "2025",
            // id_rw: { $eq: wilayah.id_rw },
            _id: { $eq: wilayah.id_rt },
            // group: { $eq: 'dataRekap' }
          },
        });
        const keluargaArray = Object.keys(keluarga).map((key) => keluarga[key]);
        const currentDate = new Date();
        const startDate = new Date(2025, 7, 18);
        const endDate = new Date(2025, 7, 21);

        function formatDate(date) {
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0"); // bulan dimulai dari 0
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        }

        function isNikInvalid(nik) {
          return (
            nik.substring(0, 5) === "12345" ||
            nik.substring(0, 5) === "00000" ||
            nik.substring(11, 16) === "00000" ||
            nik.substring(0, 6) === "010101" ||
            nik.substring(0, 6) === "030303" ||
            nik.substring(0, 6) === "090909" ||
            nik.substring(11, 16) === "66666" ||
            nik.substring(11, 16) === "88888" ||
            nik.substring(11, 16) === "55555" ||
            nik.substring(11, 16) === "11111" ||
            ((nik.substring(0, 5) === "99999" ||
              nik.substring(11, 16) === "99999") &&
              nik !== "9999999999999999") ||
            nik === "0000000000000000" ||
            nik === "1111111111111111" ||
            nik === "2222222222222222" ||
            nik === "3333333333333333" ||
            nik === "4444444444444444" ||
            nik === "5555555555555555" ||
            nik === "6666666666666666" ||
            nik === "7777777777777777" ||
            nik === "8888888888888888" ||
            nik === "9999999999999999"
          );
        }

        if (
          Object.keys(getDataRekap).length > 0 &&
          Object.keys(getDataRekap.docs).length > 0
        ) {
          // if (newDocs.length >= targetkk) {
          //     setLockOver(true)
          //     enqueueSnackbar("Jumlah yang didata telah tercapai", { variant: 'error' })
          // }
          // if(tanggal 18 agustus 2024 sampai 21 agustus 2024 )
          if (
            formatDate(currentDate) >= formatDate(startDate) &&
            formatDate(currentDate) <= formatDate(endDate)
          ) {
            keluargaArray.forEach((member) => {
              const nik = member.nik;
              if (isNikInvalid(nik)) {
                enqueueSnackbar("Ditemukan NIK yang tidak wajar", {
                  variant: "info",
                });
              } else {
                if (getDataRekap.docs[0].status === 3) {
                  setLock(true);
                  enqueueSnackbar("Data Rekap telah di lock dari Portal", {
                    variant: "error",
                  });
                }
              }
            });
          } else {
            if (getDataRekap.docs[0].status === 3) {
              setLock(true);
              enqueueSnackbar("Data Rekap telah di lock dari Portal", {
                variant: "error",
              });
            }
          }
        } else {
          const jmlDidata = newDocs.length;

          // if (jmlDidata >= targetkk) {
          //     // if (jmlDidata >= 3) {
          //     setLockOver(true)
          //     enqueueSnackbar("Jumlah yang didata telah tercapai atau target KK belum di set", { variant: 'error' })
          // }
        }
      } catch (error) {}
    };

    // if (mode !== 'edit' || (wilayah.sts_keluarga !== '1' && wilayah.sts_keluarga !== '6')) {
    // if (wilayah.sts_keluarga === '1' || wilayah.sts_keluarga === '6') {
    if (wilayah.id_rt) {
      setLock(false);
      setLockOver(false);
      getSelectedDataRekap();
    }
    // }
  }, [metadata, wilayah.id_rt, wilayah.sts_keluarga]);

  useEffect(() => {
    const getNoKeluarga = async () => {
      setLockKeluarga(false);
      if (wilayah.id_rw && wilayah.id_rt) {
        const data = await dataBkkbn.local.find({
          selector: {
            user_name: { $eq: metadata.nameProses },
            id_rw: { $eq: wilayah.id_rw },
            id_rt: { $eq: wilayah.id_rt },
            group: { $eq: "dataBkkbn" },
          },
        });

        const cek = [];
        data.docs.forEach((item) => {
          if (item.status_sensus !== "Delete") {
            if (mode === "edit") {
              if (item._id !== wilayah._id) {
                if (
                  item.no_urutkel === wilayah.no_urutkel &&
                  wilayah.no_urutkel !== "" &&
                  wilayah.no_urutkel
                ) {
                  cek.push(item);
                }
              }
            } else {
              if (
                item.no_urutkel === wilayah.no_urutkel &&
                wilayah.no_urutkel !== "" &&
                wilayah.no_urutkel
              ) {
                cek.push(item);
              }
            }
          }
        });

        if (cek.length > 0) {
          setLockKeluarga(true);
          enqueueSnackbar("Terdapat No. Urut Keluarga yang sama", {
            variant: "error",
          });
        }
      }
    };

    getNoKeluarga();
    if (!mode) {
      setLockKeluarga(false);
    }
  }, [wilayah.no_urutkel]);
  // END PERUBAHAN AMBIL YANG RT RW BKKBN

  const handleChange = (e) => {
    if (e.target.type === "number") {
      if (parseInt(e.target.value) < 0) return false;

      if (e.target.name === "no_urutkel" && e.target.value.length > 3) {
        return false;
      }

      if (e.target.name === "no_rmh" && e.target.value.length > 3) {
        return false;
      }

      if (e.target.name === "no_kk_verval" && e.target.value.length > 16) {
        return false;
      }

      if (e.target.name === "no_telepon" && e.target.value.length > 13) {
        return false;
      }

      if (e.target.name === "jumlah_keluarga") {
        if (e.target.value.length > 2) {
          return false;
        }
        setStopSegment(false);
      }

      if (e.target.name === "no_rmh") {
        setStopSegment(false);
      }

      if (e.target.name === "no_urutkel") {
        setStopSegment(false);
      }
    }

    if (e.target.name === "jumlah_keluarga") {
      if ((e.target.value + "").match(/^0/)) {
        e.target.value = (e.target.value + "").replace(/^0+/g, "");
      }
      setJmlKeluarga(e.target.value);
    } else {
      setWilayah({
        ...wilayah,
        [e.target.name]: e.target.value,
      });
    }

    if (e.target.name === "sts_keluarga") {
      setStsKeluarga(e.target.value);
    } else {
      setWilayah({
        ...wilayah,
        [e.target.name]: e.target.value,
      });
    }

    setError({
      ...error,
      [e.target.name]: "",
    });

    if (e.target.name === "id_rw") {
      if (wilayah.id_rt !== undefined) {
        setWilayah({
          ...wilayah,
          [e.target.name]: e.target.value,
          ["id_rt"]: "",
        });
      }
    }
    setSomethingChange(true);
  };

  const handleChangeUppercase = (e) => {
    setWilayah({
      ...wilayah,
      [e.target.name]: e.target.value.toUpperCase(),
    });
    setError({
      ...error,
      [e.target.name]: "",
    });
    setSomethingChange(true);
  };

  const validate = () => {
    let newError = {};

    if (!wilayah.id_rw) {
      newError.id_rw = "RW/Dusun wajib diisi";
    }

    if (!wilayah.id_rt) {
      newError.id_rt = "RT wajib diisi";
    }
    if (!wilayah.no_rmh) {
      newError.no_rmh = "No. Rumah wajib diisi";
    } else if (wilayah.no_rmh.length < 3) {
      newError.no_rmh = "No. Rumah harus 3 digit";
    } else if (!isInt(wilayah.no_rmh) || parseInt(wilayah.no_rmh) <= 0) {
      newError.no_rmh = "No. Rumah tidak valid";
    }

    if (!wilayah.no_urutkel) {
      newError.no_urutkel = "No. Urut Keluarga wajib diisi";
    } else if (
      !isInt(wilayah.no_urutkel) ||
      parseInt(wilayah.no_urutkel) <= 0
    ) {
      newError.no_urutkel = "No. Urut Keluarga tidak valid";
    } else if (wilayah.no_urutkel.length < 3) {
      newError.no_urutkel = "No. Urut Keluarga harus 3 digit";
    }

    // if (stsKeluarga === "5") {
    if (stsKeluarga === "2" || stsKeluarga === "3" || stsKeluarga === "4") {
      if (wilayah.no_kk_verval) {
        if (wilayah.no_kk_verval.length !== 16) {
          newError.no_kk_verval = "No. Kartu Keluarga (KK) harus 16 digit";
        } else if (wilayah.no_kk_verval === "0000000000000000") {
          newError.no_kk_verval = "No. Kartu Keluarga (KK) tidak boleh 0 16x";
        }
      }
    } else {
      if (!wilayah.no_kk_verval) {
        newError.no_kk_verval = "No. Kartu Keluarga (KK) wajib diisi";
      } else if (wilayah.no_kk_verval.length !== 16) {
        newError.no_kk_verval = "No. Kartu Keluarga (KK) harus 16 digit";
      } else if (wilayah.no_kk_verval === "0000000000000000") {
        newError.no_kk_verval = "No. Kartu Keluarga (KK) tidak boleh 0 16x";
      } else if (wilayah.no_kk_verval === "1111111111111111") {
        newError.no_kk_verval = "No. Kartu Keluarga (KK) tidak boleh 1 16x";
      } else if (wilayah.no_kk_verval === "2222222222222222") {
        newError.no_kk_verval = "No. Kartu Keluarga (KK) tidak boleh 2 16x";
      } else if (wilayah.no_kk_verval === "3333333333333333") {
        newError.no_kk_verval = "No. Kartu Keluarga (KK) tidak boleh 3 16x";
      } else if (wilayah.no_kk_verval === "4444444444444444") {
        newError.no_kk_verval = "No. Kartu Keluarga (KK) tidak boleh 4 16x";
      } else if (wilayah.no_kk_verval === "5555555555555555") {
        newError.no_kk_verval = "No. Kartu Keluarga (KK) tidak boleh 5 16x";
      } else if (wilayah.no_kk_verval === "6666666666666666") {
        newError.no_kk_verval = "No. Kartu Keluarga (KK) tidak boleh 6 16x";
      } else if (wilayah.no_kk_verval === "7777777777777777") {
        newError.no_kk_verval = "No. Kartu Keluarga (KK) tidak boleh 7 16x";
      } else if (wilayah.no_kk_verval === "8888888888888888") {
        newError.no_kk_verval = "No. Kartu Keluarga (KK) tidak boleh 8 16x";
      }
    }

    if (!jmlKeluarga) {
      newError.jumlah_keluarga = "Jumlah Anggota Keluarga wajib diisi";
      // } else if (!isInt(jmlKeluarga) || parseInt(jmlKeluarga) <= 0) {
    } else if (
      jmlKeluarga?.length === 0 ||
      parseInt(jmlKeluarga) <= 0 ||
      parseInt(jmlKeluarga) >= 100
    ) {
      newError.jumlah_keluarga = "Jumlah Anggota Keluarga tidak valid";
    }

    if (!stsKeluarga) {
      newError.sts_keluarga = "Status Keluarga wajib diisi";
    }

    if (!wilayah.alamat) {
      newError.alamat = "Alamat wajib diisi";
    }

    if (!wilayah.sts_keluarga) {
      newError.sts_keluarga = "Status Keluarga wajib diisi";
    }

    //
    //
    // if(locationUser.length === 0 && isOnline){
    //     newError.sts_keluarga = "Geo Location belum diaktifkan";
    //     let message = `Geo Location belum diaktifkan, silakan buka pengaturan browser dan ijinkan aplikasi untuk mengakses Location`
    //     enqueueSnackbar(message, { variant: "error" })
    // }

    return newError;
  };

  const handleValidasiCapaian = async () => {
    let rw = metadata.wil_rw.find(
      (el) => parseInt(el.id_rw) === parseInt(wilayah.id_rw)
    );
    let rt = {};
    if (rw && wilayah.id_rt) {
      rt = rw.wil_rt.find(
        (elrt) => parseInt(elrt.id_rt) === parseInt(wilayah.id_rt)
      );
    }
    //
    const targetRt = +rt.targetkk;
    const opr = await localStorage.getItem("opr");
    const localRw = await localStorage.getItem("rw");
    const username = metadata.nameProsesProses;
    let selector = {
      user_name: username,
      periode_sensus: "2025",
      id_rt: wilayah.id_rt,
      status_sensus: {
        $in: [
          "Valid",
          "NotValid",
          "Received",
          "Anomali",
          "Anomali Terkonfirmasi",
          "",
          "Tersimpan",
        ],
      },
      sts_keluarga: {
        $in: ["1", "5"],
      },
      status_draft: { $ne: "1" },
    };

    if (opr == "true" && localRw != "false") {
      selector = {
        user_name: username,
        id_rw: localRw,
        id_rt: wilayah.id_rt,
        periode_sensus: "2025",
        status_sensus: {
          $in: [
            "Valid",
            "NotValid",
            "Received",
            "Anomali",
            "Anomali Terkonfirmasi",
            "",
            "Tersimpan",
          ],
        },
        sts_keluarga: {
          $in: ["1", "5"],
        },
        status_draft: { $ne: "1" },
      };
    }
    let capaianRt = 0;
    await dataBkkbn.local
      .find({
        selector: selector,
      })
      .then(async (results) => {
        //
        capaianRt = results.docs.length;
      })
      .catch(function (err) {});
    if (capaianRt < targetRt) {
      return false;
    } else {
      return true;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const findErrors = validate();

    const errorValues = Object.values(findErrors);

    if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
      setError(findErrors);
    } else {
      const validasiCapaian = handleValidasiCapaian();
      if (lock === true) {
        enqueueSnackbar("Data Rekap telah di lock dari Portal", {
          variant: "error",
        });
        // } else if (lockOver === true && wilayah.status_sensus !== 'Anomali' && wilayah.status_sensus != 'NotValid' && (wilayah.sts_keluarga === '1' || wilayah.sts_keluarga === '6')) {
        // } else if (lockOver === true && wilayah.status_sensus !== 'Anomali' && wilayah.status_sensus != 'NotValid' && (wilayah.sts_keluarga === '1' || wilayah.sts_keluarga === '6')) {
        //
        //     //
        //     enqueueSnackbar("Jumlah yang didata telah tercapai", { variant: 'error' })
      } else if (
        validasiCapaian &&
        (wilayah.sts_keluarga === "2" ||
          wilayah.sts_keluarga === "3" ||
          wilayah.sts_keluarga === "4" ||
          wilayah.sts_keluarga === null) &&
        (wilayah.sts_keluarga === "1" || wilayah.sts_keluarga === "5")
      ) {
        enqueueSnackbar(
          "Pendataan RT" + wilayah.id_rt_bkkbn + "telah mencapai target",
          { variant: "error" }
        );
      } else if (lockKeluarga === true) {
        enqueueSnackbar("Terdapat No. Urut Keluarga yang sama", {
          variant: "error",
        });
      } else {
        let id_rw_bkkbn = metadata.wil_rw.find(
          (rw) => parseInt(rw.id_rw) === parseInt(wilayah.id_rw)
        ).id_rw_bkkbn;
        let id_rt_bkkbn = metadata.wil_rw
          .find((rw) => parseInt(rw.id_rw) === parseInt(wilayah.id_rw))
          .wil_rt.find(
            (rt) => parseInt(rt.id_rt) === parseInt(wilayah.id_rt)
          ).id_rt_bkkbn;
        const no_kk = `${metadata.wil_provinsi.id_provinsi_depdagri}${metadata.wil_kabupaten.id_kabupaten_depdagri}${metadata.wil_kecamatan.id_kecamatan_depdagri}${metadata.wil_kelurahan.id_kelurahan_depdagri}${id_rw_bkkbn}${id_rt_bkkbn}P${wilayah.no_rmh}${wilayah.no_urutkel}`;
        // console.log("no_kk", no_kk);
        //setForm()
        setSubmitting(true);
        cekNomor(no_kk).then((res) => {
          // console.log("res cekNomor", res);
          if (res) {
            setWilayah({
              ...wilayah,
              ["year_doc"]: wilayah.year_doc ? wilayah.year_doc : "2025",
              ["id_rw_bkkbn"]: id_rw_bkkbn,
              ["id_rt_bkkbn"]: id_rt_bkkbn,
              ["no_kk"]: no_kk,
              ["jumlah_keluarga"]: jmlKeluarga,
            });

            setSomethingChange(false);
            handleNext();
            setSubmitting(false);
          } else {
            let message = `Terdapat Data yang sama`;
            enqueueSnackbar(message, { variant: "warning" });
            setSubmitting(false);
          }
        });
      }
    }
  };

  const cekNomor = async (no_kk) => {
    // if (stsKeluarga === "5" && !wilayah.no_kk_verval) {
    if (
      (stsKeluarga === "2" || stsKeluarga === "3" || stsKeluarga === "4") &&
      !wilayah.no_kk_verval
    ) {
      const query = await dataBkkbn.local.find({
        selector: {
          no_kk: { $eq: no_kk },
        },
      });

      const newData = [];
      if (query.docs.length > 0) {
        query.docs.forEach((item) => {
          if (item.status_sensus != "Delete") {
            newData.push(item);
          }
        });
      }

      if (newData.length === 0 || mode === "edit") {
        if (mode === "edit") {
          if (newData.length > 0) {
            if (wilayah._id == newData[0]._id) {
              if (!isSomethingChange) {
                return true;
              }
              return true;
            } else {
              return false;
            }
          }
          return true;
        } else {
          if (!isSomethingChange) {
            return true;
          }
          return true;
        }
      } else {
        return false;
      }
    } else {
      const selector = {};
      const orConditions = [];
      if (no_kk) {
        orConditions.push({ no_kk: { $eq: no_kk } });
      }
      // if (wilayah.no_kk_verval) {
      //   orConditions.push({ no_kk_verval: { $eq: wilayah.no_kk_verval } });
      // }
      if (orConditions.length === 0) {
        return true;
      }

      selector.$or = orConditions;

      const query = await dataBkkbn.local.find({
        selector: selector,
      });

      const newData = [];
      if (query.docs.length > 0) {
        query.docs.forEach((item) => {
          if (item.status_sensus != "Delete") {
            newData.push(item);
          }
        });
      }

      if (newData.length === 0 || mode === "edit") {
        if (mode === "edit") {
          // if (newData.length > 0) {
          //   // if (wilayah._id == newData[0]._id) {
          //   //   return true;
          //   // } else {
          //   //   return false;
          //   // }
          //   return true;
          // }
          return true;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  };

  const handleSubmite = async (e) => {
    e.preventDefault();

    const findErrors = validate();

    const errorValues = Object.values(findErrors);

    if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
      setError(findErrors);
    } else {
      // setWilayah({
      //     ...wilayah,
      //     ["jumlah_keluarg"]: jmlKeluarga
      // })

      let id_rw_bkkbn = metadata.wil_rw.find(
        (rw) => parseInt(rw.id_rw) === parseInt(wilayah.id_rw)
      ).id_rw_bkkbn;
      let id_rt_bkkbn = metadata.wil_rw
        .find((rw) => parseInt(rw.id_rw) === parseInt(wilayah.id_rw))
        .wil_rt.find(
          (rt) => parseInt(rt.id_rt) === parseInt(wilayah.id_rt)
        ).id_rt_bkkbn;
      const no_kk = `${metadata.wil_provinsi.id_provinsi_depdagri}${metadata.wil_kabupaten.id_kabupaten_depdagri}${metadata.wil_kecamatan.id_kecamatan_depdagri}${metadata.wil_kelurahan.id_kelurahan_depdagri}${id_rw_bkkbn}${id_rt_bkkbn}${wilayah.no_rmh}${wilayah.no_urutkel}`;
      const query = await dataBkkbn.local.find({
        selector: {
          no_kk: {
            $eq: wilayah.no_kk,
          },
        },
      });

      if (query.docs.length === 0 || mode === "edit") {
        if (!isSomethingChange) {
          return handleNext();
        }

        //simpan ke db local
        setSubmitting(true);
        try {
          setWilayah({
            ...wilayah,
            ["year_doc"]: wilayah.year_doc ? wilayah.year_doc : "2025",
            ["id_rw_bkkbn"]: id_rw_bkkbn,
            ["id_rt_bkkbn"]: id_rt_bkkbn,
            ["no_kk"]: "",
            ["no_kk_verval"]: wilayah.no_kk_verval, // Menggunakan nilai dari input
            ["no_kk_lama"]: "",
            ["jumlah_keluarga"]: jmlKeluarga,
          });

          setSomethingChange(false);
          handleNext();
        } catch (e) {
          setSubmitting(false);
          if (e.name === "not_found") {
            try {
              // await dataKK.local.put({
              //     _id: wilayah.no_kk,
              //     type: 'utama',
              //     ...wilayah
              // })

              setSomethingChange(false);
              handleNext();
            } catch (e) {
              enqueueSnackbar(e.message, { variant: "error" });
            }
          } else {
            enqueueSnackbar(e.message, { variant: "error" });
          }
        }
      } else {
        let message = `Terdapat Data yang sama`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    }
    //
    //
  };

  const handleCheckSegmen = async (event) => {
    const { value } = event.target;
    // console.log("value", value);

    if (value === "0") {
      handleSegmen(event, 0);
      return;
    }

    if (
      value === "1" &&
      (wilayah.sts_keluarga === "2" ||
        wilayah.sts_keluarga === "3" ||
        wilayah.sts_keluarga === "4")
    ) {
      const findErrors = validate();
      const errorValues = Object.values(findErrors);

      if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
        setError(findErrors);
        enqueueSnackbar("Form Wilayah belum lengkap", { variant: "warning" });
        return;
      }
      enqueueSnackbar(
        'Status Keluarga Selain "Ada" Tidak Bisa ke Segmen Keluarga, KB, dan PK',
        { variant: "error" }
      );
      return;
    }

    if (value === "1") {
      const findErrors = validate();
      const errorValues = Object.values(findErrors);

      if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
        setError(findErrors);
        enqueueSnackbar("Form Wilayah belum lengkap", { variant: "warning" });
        return;
      }
      handleSegmen(event, 1);
      return;
    }

    if (
      value === "2" &&
      (wilayah.sts_keluarga === "2" ||
        wilayah.sts_keluarga === "3" ||
        wilayah.sts_keluarga === "4")
    ) {
      const findErrors = validate();
      const errorValues = Object.values(findErrors);

      if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
        setError(findErrors);
        enqueueSnackbar("Form Wilayah belum lengkap", { variant: "warning" });
        return;
      }
      enqueueSnackbar(
        'Status Keluarga Selain "Ada" Tidak Bisa ke Segmen Keluarga, KB, dan PK',
        { variant: "error" }
      );
      return;
    }

    if (value === "2") {
      const findErrors = validate();
      const errorValues = Object.values(findErrors);

      if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
        setError(findErrors);
        enqueueSnackbar("Form Wilayah belum lengkap", { variant: "error" });
        return;
      } else {
        handleSegmen(event, 1);
        // return
      }

      const jumlahKeluarga = parseInt(wilayah.jumlah_keluarga || 0);
      let keluargaKosong = true;
      for (let i = 1; i <= jumlahKeluarga; i++) {
        const anggota = keluarga[i];
        console.log("anggota", anggota);

        if (
          anggota &&
          anggota.nama_anggotakel &&
          anggota.nik &&
          anggota.jenis_kelamin &&
          anggota.tgl_lahir &&
          anggota.sts_kawin &&
          anggota.usia_kawin &&
          anggota.sts_akta &&
          anggota.sts_hubungan &&
          anggota.id_agama &&
          anggota.jenis_pekerjaan &&
          anggota.bekerja_luar_negeri &&
          anggota.jns_pendidikan &&
          anggota.jns_asuransi &&
          anggota.disabilitas &&
          anggota.disabilitas.length > 0
        ) {
          console.log("anggota valid", anggota.nama_anggotakel, anggota.nik);
          keluargaKosong = false;
          break;
        }
      }
      if (keluargaKosong) {
        enqueueSnackbar("Isi data keluarga terlebih dahulu sebelum ke KB", {
          variant: "warning",
        });
        handleSegmen(event, 1);
        return;
      }
      handleSegmen(event, jumlahKeluarga + 1);
      return;
    }

    if (
      value === "3" &&
      (wilayah.sts_keluarga === "2" ||
        wilayah.sts_keluarga === "3" ||
        wilayah.sts_keluarga === "4")
    ) {
      const findErrors = validate();
      const errorValues = Object.values(findErrors);

      if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
        setError(findErrors);
        enqueueSnackbar("Form Wilayah belum lengkap", { variant: "warning" });
        return;
      }
      enqueueSnackbar(
        'Status Keluarga Selain "Ada" Tidak Bisa ke Segmen Keluarga, KB, dan PK',
        { variant: "error" }
      );
      return;
    }

    if (value === "3") {
      const findErrors = validate();
      const errorValues = Object.values(findErrors);

      if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
        setError(findErrors);
        enqueueSnackbar("Form Wilayah belum lengkap", { variant: "error" });
        return;
      } else {
        handleSegmen(event, 1);
      }

      const jumlahKeluarga = parseInt(wilayah.jumlah_keluarga || 0);
      let keluargaKosong = true;
      for (let i = 1; i <= jumlahKeluarga; i++) {
        const anggota = keluarga[i];
        console.log("anggota", anggota);

        if (
          anggota &&
          anggota.nama_anggotakel &&
          anggota.nik &&
          anggota.jenis_kelamin &&
          anggota.tgl_lahir &&
          anggota.sts_kawin &&
          anggota.usia_kawin &&
          anggota.sts_akta &&
          anggota.sts_hubungan &&
          anggota.id_agama &&
          anggota.jenis_pekerjaan &&
          anggota.bekerja_luar_negeri &&
          anggota.jns_pendidikan &&
          anggota.jns_asuransi &&
          anggota.disabilitas &&
          anggota.disabilitas.length > 0
        ) {
          console.log("anggota valid", anggota.nama_anggotakel, anggota.nik);
          keluargaKosong = false;
          break;
        }
      }
      if (keluargaKosong) {
        enqueueSnackbar(
          "Isi data keluarga terlebih dahulu sebelum ke KB dan PK",
          {
            variant: "warning",
          }
        );
        handleSegmen(event, 1);
        return;
      }
      console.log(">>>>>", kb);

      if (
        !kb ||
        Object.values(kb).length === 0 ||
        !kb["0101"] ||
        kb["0101"].kelahiran === undefined ||
        kb["0101"].lahir_hidup_laki_laki === undefined ||
        kb["0101"].lahir_hidup_perempuan === undefined ||
        kb["0101"].masih_hidup_laki_laki === undefined ||
        kb["0101"].masih_hidup_perempuan === undefined
      ) {
        enqueueSnackbar(
          "Lengkapi Form KB Terlebih Dahulu Sebelum Menuju Ke Segmen PK",
          {
            variant: "warning",
          }
        );
        handleSegmen(event, jumlahKeluarga + 1);
        return;
      }
      handleSegmen(event, jumlahKeluarga + 2);
      return;
    }

    if (
      wilayah.sts_keluarga !== "2" &&
      wilayah.sts_keluarga !== "3" &&
      wilayah.sts_keluarga !== "4"
    ) {
      const findErrors = validate();

      const errorValues = Object.values(findErrors);

      // const promiseKLG = [];

      // for (let i = 1; i <= docKK?.data_nik?.length; i++) {
      //   promiseKLG.push(validatePerKepala(i, keluarga));
      //   if (i === 1) {
      //     enqueueSnackbar("Form Keluarga belum lengkap", { variant: "error" });
      //   }
      // }

      try {
        if (
          Object.keys(docKK.data_kb[6]).length > 0 &&
          docKK.data_kb[6].answer[0].No_Jawaban !== "9" &&
          (docKK.data_kb[7].answer[0].No_Jawaban === null ||
            docKK.data_kb[8].answer[0].pilihankb === "" ||
            docKK.data_kb[8].answer[1].pilihankb === "" ||
            docKK.data_kb[8].answer[2].pilihankb === "")
        ) {
          enqueueSnackbar("Form KB belum lengkap", { variant: "error" });
        } else if (
          Object.keys(docKK.data_kb[2]).length > 0 &&
          docKK.data_kb[2].answer[0].No_Jawaban === "2" &&
          docKK.data_kb[3].answer[0].No_Jawaban === null
        ) {
          enqueueSnackbar("Form KB belum lengkap", { variant: "error" });
        } else if (
          Object.keys(docKK.data_kb[3]).length > 0 &&
          docKK.data_kb[3].answer[0].No_Jawaban === "2" &&
          (docKK.data_kb[4].answer[0].No_Jawaban === null ||
            docKK.data_kb[5].answer[0].No_Jawaban === null)
        ) {
          enqueueSnackbar("Form KB belum lengkap", { variant: "error" });
        } else if (
          Object.keys(docKK.data_kb[5]).length > 0 &&
          docKK.data_kb[4].answer[0].No_Jawaban === "1" &&
          (Object.keys(docKK.data_kb[6]).length === 0 ||
            (Object.keys(docKK.data_kb[6]).length > 0 &&
              docKK.data_kb[6].answer[0].No_Jawaban === null))
        ) {
          enqueueSnackbar("Form KB belum lengkap", { variant: "error" });
        }
      } catch (error) {
        enqueueSnackbar("Form KB belum lengkap", { variant: "error" });
      }

      if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
        setError(findErrors);
      } else {
        if (stopSegment === false) {
          enqueueSnackbar("Silahkan Klik Selanjutnya", { variant: "warning" });
        } else {
          const { value } = event.target;
          //
          // const x = Object.keys(keluarga).length;
          const x = parseInt(wilayah.jumlah_keluarga);

          if (value) {
            let val = parseInt(value);
            //
            if (x > 1) {
              val > 1 ? (val = val + x - 1) : (val = val);
            }

            let segment_pus = wilayah.pertanyaan_pus || "";
            if ((x === 1 && val === 2) || (segment_pus !== 1 && value === 4)) {
              let message;
              if (val === 2) {
                message = `Data KB tidak Tersedia`;
              } else {
                message = `Data Stunting tidak Tersedia`;
              }

              enqueueSnackbar(message, { variant: "warning" });
            } else {
              //
              // handleSegmen(event, val);
            }
          }
        }
      }
    }
  };

  useEffect(() => {
    if (wilayah.jumlah_keluarga) {
      setJmlKeluarga(wilayah.jumlah_keluarga);
    }
  }, [wilayah.jumlah_keluarga]);

  return (
    <Swipeable
      trackMouse={true}
      onSwipedLeft={(e) => {
        if (nextRef) {
          nextRef.current.click();
        }
      }}
    >
      <form onSubmit={handleSubmit} className={classes.form}>
        <ScrollToTopWithoutRouter />
        <Grid container spacing={3}>
          <Grid item xs={12} className={classes.textCenter}>
            <Typography variant="h5" component="h1">
              {mode === "edit"
                ? `Edit Form Data Kependudukan`
                : "Form Data Kependudukan"}
            </Typography>
            {/* {mode === 'edit' && <Typography>No KK: {wilayah.no_kk}</Typography>} */}
          </Grid>

          <Grid item xs className={classes.textLeft}>
            {mode === "edit" &&
            (wilayah.status_draft === undefined ||
              wilayah.status_draft === "2") ? (
              <>
                <FormControl variant="outlined">
                  <Select
                    id=""
                    value=""
                    name="segmen"
                    onChange={handleCheckSegmen}
                    displayEmpty
                  >
                    <MenuItem value=""> Segmen </MenuItem>
                    <MenuItem value="0"> Wilayah </MenuItem>
                    <MenuItem value="1"> Keluarga </MenuItem>
                    <MenuItem value="2"> KB </MenuItem>
                    <MenuItem value="3"> PK </MenuItem>
                    {/* <MenuItem value="4"> Stunting </MenuItem> */}
                  </Select>
                </FormControl>
              </>
            ) : (
              <></>
            )}
          </Grid>

          <Grid item>
            {mode === "edit" && wilayah.status_sensus === "Anomali" ? (
              <>
                {" "}
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleAnomali("local", 1)}
                  disabled={isSubmitting.local || isSaved.local}
                >
                  <AssignmentTurnedInIcon /> Anomali Terkonfirmasi{" "}
                </Button>{" "}
              </>
            ) : (
              <></>
            )}
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography>
              Provinsi: {metadata.wil_provinsi.nama_provinsi}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography>
              Kabupaten/Kota: {metadata.wil_kabupaten.nama_kabupaten}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography>
              Kecamatan: {metadata.wil_kecamatan.nama_kecamatan}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography>
              Desa/Kel: {metadata.wil_kelurahan.nama_kelurahan}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography>
              Klasifikasi Desa/Kelurahan:{" "}
              {metadata.wil_kelurahan.klasifikasiDesa === 1
                ? "PERKOTAAN"
                : metadata.wil_kelurahan.klasifikasiDesa === 2
                ? "PERDESAAN"
                : "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography>
              Lokus: {metadata.wil_kelurahan.lokus_verval_pk25 || "-"}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl
              disabled={isSubmitting}
              variant="outlined"
              fullWidth
              error={error.id_rw ? true : false}
            >
              <Select
                id="id_rw"
                value={wilayah.id_rw || ""}
                onChange={handleChange}
                name="id_rw"
                displayEmpty
              >
                <MenuItem value="">Pilih RW/Dusun</MenuItem>

                {metadata.wil_rw.map((rw) => (
                  <MenuItem key={rw.id_rw} value={rw.id_rw}>
                    {rw.id_rw_bkkbn} - {rw.nama_rw}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{error.id_rw}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl
              disabled={isSubmitting || !wilayah.id_rw}
              variant="outlined"
              fullWidth
              error={error.id_rt ? true : false}
            >
              <Select
                id="id_rt"
                value={wilayah.id_rt || ""}
                onChange={handleChange}
                name="id_rt"
                displayEmpty
              >
                <MenuItem value="">Pilih RT</MenuItem>
                {wilayah.id_rw &&
                  // metadata.wil_rt &&
                  metadata.wil_rw
                    .find(
                      (rw) => parseInt(rw.id_rw) === parseInt(wilayah.id_rw)
                    )
                    ?.wil_rt.map((rt) => (
                      <MenuItem key={rt.id_rt} value={rt.id_rt}>
                        {rt.id_rt_bkkbn} - {rt.nama_rt}
                      </MenuItem>
                    ))}
              </Select>
              <FormHelperText>{error.id_rt}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              disabled={isSubmitting}
              fullWidth
              variant="outlined"
              placeholder="No. Rumah"
              value={wilayah.no_rmh || ""}
              name="no_rmh"
              id="no_rmh"
              // type="number"
              type="number"
              inputProps={{
                min: 0,
                maxLength: 3,
              }}
              onChange={handleChange}
              error={error.no_rmh ? true : false}
              helperText={error.no_rmh}
              autoComplete="off"
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              disabled={isSubmitting}
              fullWidth
              variant="outlined"
              placeholder="No. Urut Keluarga"
              value={wilayah.no_urutkel || ""}
              name="no_urutkel"
              id="no_urutkel"
              type="number"
              inputProps={{
                min: 0,
                maxLength: 3,
              }}
              onChange={handleChange}
              error={error.no_urutkel ? true : false}
              helperText={error.no_urutkel}
              autoComplete="off"
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              disabled={isSubmitting}
              fullWidth
              variant="outlined"
              placeholder="No. Kartu Keluarga"
              value={wilayah.no_kk_verval || ""}
              name="no_kk_verval"
              id="no_kk_verval"
              type="number"
              inputProps={{
                min: 0,
                maxLength: 3,
              }}
              onChange={handleChange}
              error={error.no_kk_verval ? true : false}
              helperText={error.no_kk_verval}
              autoComplete="off"
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
              style={{
                backgroundColor:
                  wilayah.no_kk_verval === "9999999999999999"
                    ? "red"
                    : "transparent",
                color:
                  wilayah.no_kk_verval === "9999999999999999"
                    ? "white"
                    : "inherit",
              }}
              InputProps={{
                style: {
                  backgroundColor:
                    wilayah.no_kk_verval === "9999999999999999"
                      ? "red"
                      : "transparent",
                  color:
                    wilayah.no_kk_verval === "9999999999999999"
                      ? "white"
                      : "inherit",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              disabled={isSubmitting}
              fullWidth
              variant="outlined"
              placeholder="No. Telepon/Hp"
              value={wilayah.no_telepon || ""}
              name="no_telepon"
              id="no_telepon"
              type="number"
              inputProps={{
                min: 0,
                maxLength: 13,
              }}
              onChange={handleChange}
              autoComplete="off"
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
            />
          </Grid>

          <Grid item xs={12} md={12}>
            <TextField
              disabled={isSubmitting}
              fullWidth
              variant="outlined"
              style={{ textTransform: "uppercase" }}
              placeholder="Alamat"
              // multiline
              rows={2}
              rowsMax={2}
              value={wilayah.alamat || ""}
              name="alamat"
              id="alamat"
              onChange={handleChangeUppercase}
              error={error.alamat ? true : false}
              helperText={error.alamat}
              autoComplete="off"
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
              inputProps={{
                min: 0,
                maxLength: 25,
              }}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              disabled={isSubmitting}
              fullWidth
              variant="outlined"
              placeholder="Jumlah Anggota Keluarga"
              value={jmlKeluarga || ""}
              name="jumlah_keluarga"
              id="jumlah_keluarga"
              type="number"
              inputProps={{
                min: 0,
              }}
              onChange={handleChange}
              error={error.jumlah_keluarga ? true : false}
              helperText={error.jumlah_keluarga}
              autoComplete="off"
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
            />
          </Grid>
          <Grid item xs={12} md={8}>
            <FormControl
              disabled={isSubmitting}
              variant="outlined"
              fullWidth
              error={error.sts_keluarga ? true : false}
            >
              {(wilayah.cfm === 1 || wilayah.cfm === true) && (
                <span
                  style={{
                    backgroundColor: "#ff4040ff",
                    color: "white",
                    borderRadius: "8px",
                    padding: "4px 8px",
                    fontSize: "11px",
                    marginLeft: "5px",
                    fontWeight: "bold",
                    display: "inline-flex",
                    alignItems: "center",
                    verticalAlign: "middle",
                    height: "16px",
                    lineHeight: "1",
                    position: "absolute",
                    top: "-18px",
                    minWidth: "24px",
                    justifyContent: "center",
                    right: 0,
                  }}
                >
                  CFM
                </span>
              )}
              <Select
                id="sts_keluarga"
                value={wilayah.sts_keluarga || ""}
                onChange={handleChange}
                name="sts_keluarga"
                displayEmpty
                disabled={disabledSk}
              >
                <MenuItem value="">Status Keluarga</MenuItem>
                <MenuItem value="1">1. Ada</MenuItem>
                <MenuItem value="2">2. Pindah</MenuItem>
                <MenuItem value="3">
                  3. Seluruh Anggota Meninggal Dunia
                </MenuItem>
                <MenuItem value="4">4. Tidak Ditemukan</MenuItem>
                {!skipSk6 && <MenuItem value="5">5. Keluarga Baru</MenuItem>}
              </Select>
              <FormHelperText>{error.sts_keluarga}</FormHelperText>
            </FormControl>
          </Grid>

          {/* <Grid item xs className={classes.textLeft}>
                        {
                            mode == "edit" && (wilayah.status_draft == undefined || wilayah.status_draft == '2') ?
                                <>
                                    <FormControl
                                        variant="outlined">
                                        <Select
                                            id=""
                                            value=""
                                            name="segmen"
                                            onChange={handleCheckSegmen}
                                            displayEmpty
                                        >
                                            <MenuItem value=""> Segmen </MenuItem>
                                            <MenuItem value="0"> Wilayah </MenuItem>
                                            <MenuItem value="1"> Keluarga </MenuItem>
                                            <MenuItem value="2"> KB </MenuItem>
                                            <MenuItem value="3"> PK </MenuItem>
                                        </Select>
                                    </FormControl>
                                </> : <></>
                        }
                    </Grid> */}

          <Grid item xs></Grid>

          <Grid item>
            {isSubmitting && <CircularProgress size={14} />}
            <Button ref={nextRef} disabled={isSubmitting} type="submit">
              Selanjutnya <ChevronRight className={classes.iconRight} />
            </Button>
          </Grid>
        </Grid>
      </form>
    </Swipeable>
  );
}

Wilayah.propTypes = {
  wilayah: PropTypes.any.isRequired,
  setWilayah: PropTypes.func.isRequired,
};

// export default compose(connect(
//     ({ keluarga }) => ({
//         keluarga
//     }),
//     { setKeluarga }
// ), withRouter)
//     (Wilayah);
//

export default Wilayah;
